<div *ngFor="let post of posts">
  <div class="blog-post-container">
    <app-blog-post [post]="post"></app-blog-post>
  </div>
</div>